import React, { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import InputLabel from 'components/layout/forms/InputLabel';
import NumberWithUnitInputField from 'components/layout/forms/NumberWithUnitInputField';
import formatGroupedNumber from 'services/numbers/formatGroupedNumber';
import translations from 'services/translations/translations';

/**
 * The unit of the position (e.g. m2) for the rows of the calculation window. The quantities of
 * the rows are for one unit of the position, so each row shows its selling price for one unit
 * of the position in a column of its own, e.g. 1,1 jm × 3,90 €/jm = 4,29 €/m². The rows add
 * up to the selling price of the position.
 */
export const PositionUnitContext = createContext<string>('');

// The title of the column, e.g. "Myyntihinta /m²"
export const PositionUnitPriceHeader = (): JSX.Element => {
  const { t } = useTranslation([translations.common, translations.offers]);
  const unit = useContext(PositionUnitContext);

  return (
    <InputLabel>
      {`${t(`${translations.calculationWindow}:Selling short`)} /${
        unit === '' ? '' : t(`${translations.common}:units:${unit}`)
      }`}
    </InputLabel>
  );
};

// The selling price of the row for one unit of the position
const PositionUnitPrice = ({ price }: { price: number }): JSX.Element => (
  <NumberWithUnitInputField
    disabled
    unit="€"
    value={formatGroupedNumber(price)}
  />
);

export default PositionUnitPrice;
